import React, { useState } from 'react';


import {
    getLookupRole,
    getLookupServiceLocation,
    //clearCacheMaster,
    getLookupDepartment,
    getListOfValueByType,
    getLookupLocation,
    getLocationByPoint,
    getLookupListOfValueByType,
    getLookupMachineHistory,
    getLookupWorkShift,
} from '../utils/api-action';


const lookupDepartment = async () => {

    let data = [];
    //const [data, setData] = useState([]);
    var result = await getLookupDepartment()
    const { code, content, description } = result;
    if (code === 200) {
        //data = content?.data;
    } else if (code === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const lookupWorkShift = async () => {

    let data = [];
    //const [data, setData] = useState([]);
    var result = await getLookupWorkShift()
    const { code, content, description } = result;
    if (code === 200) {
        //data = content?.data;
    } else if (code === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}


const lookupListOfValueByType = async (param) => {


    var result = await getListOfValueByType(param)
    const { code, content, description } = result;
    if (code === 200) {
        //data = content?.data;
    } else if (code === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const lookupRole = async (param) => {

    let data = [];
    //const [data, setData] = useState([]);
    var result = await getLookupRole(param)
    const { code, content, description } = result;
    if (code === 200) {
        //data = content?.data;
    } else if (code === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const lookupMachineHistory = async (param) => {

    let data = [];
    //const [data, setData] = useState([]);
    var result = await getLookupMachineHistory(param)
    const { code, content, description } = result;
    if (code === 200) {
        //data = content?.data;
    } else if (code === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const lookupServiceLocation = async () => {

    let param = {
        search: "",
        take: 1000
    };
    //let data = [];
    //const [data, setData] = useState([]);
    var result = await getLookupServiceLocation(param)
    const { code, content, description } = result;
    if (code === 200) {
        //data = content?.data;
    } else if (code === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const lookupLocations = async () => {


    var result = await getLookupLocation()


    return result;

}

const locationByPoint = async (param) => {
    var result = await getLocationByPoint(param)
    return result;

}

const lookupListOfValueByTypes = async (param) => {
    var result = await getLookupListOfValueByType(param)
    return result;

}



//const clearCache = async () => {

//    let param = {
//        search: "",
//        take: 500
//    };

//    var result = await clearCacheMaster(param)
//    const { code, content, description } = result;
//    if (code === 200) {
//        //data = content?.data;
//    } else if (code === 401) {
//        localStorage.clear();
//    }
//    else {

//    }

//    return result;

//}



export {
    lookupRole,
    lookupServiceLocation,
    lookupDepartment,
    lookupListOfValueByType,
    lookupLocations,
    locationByPoint,
    lookupListOfValueByTypes,
    lookupMachineHistory,
    lookupWorkShift
};
